import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { Subscription } from "../models/Subscription";
import { NotificationMessage } from "../models/NotificationMessage";
import { QuerySearchNotification } from "../models/QuerySearchNotification";
import { Notification } from "../models/Notification";

export class NotificationService {
  baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_NOTIFICATIONS_API}/notifications`;
  }

  async saveSubscription(data: Subscription): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/subscription`;
    const response = await axios.post(serviceURL, JSON.stringify(data));
    return response.data;
  }

  async sendNotification(data: Notification): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/send`;
    const response = await axios.post(serviceURL, JSON.stringify(data));
    return response.data;
  }

  async deleteSubscription(
    subscription: Subscription
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/by-subscription-and-user`;
    const response = await axios.delete(serviceURL, {
      data: subscription
    });
    return response.data;
  }

  async getNotificationsByUser(
    id: string
  ): Promise<Response<Array<NotificationMessage> | void>> {
    const serviceURL = `${this.baseUrl}/by-user?userId=${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getNotificationsByUserProfile(
    id: string,
    query?: QuerySearchNotification
  ) {
    const serviceURL = `${this.baseUrl}/by-user-profile?userId=${id}`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getScheduledActions(id: string, query?: QuerySearchNotification) {
    const serviceURL = `${this.baseUrl}/scheduled-actions?userId=${id}`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getScheduledNotifications(id: string, query?: QuerySearchNotification) {
    const serviceURL = `${this.baseUrl}/scheduled?userId=${id}`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async cancelScheduledNotification(id: string, userId: string) {
    const serviceURL = `${this.baseUrl}/cancel-scheduled-notification/${id}?userId=${userId}`;
    const response = await axios.post(serviceURL);
    return response.data;
  }

  async cancelScheduledAction(id: string, userId: string) {
    const serviceURL = `${this.baseUrl}/cancel-scheduled-action/${id}?userId=${userId}`;
    const response = await axios.put(serviceURL);
    return response.data;
  }

  async deleteNotification(
    notificationId: string
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${notificationId}`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }

  async getWhatsappTemplateByTempId(tempId: string) {
    const serviceURL = `${this.baseUrl}/app/template/${tempId}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async updateStateNotificationById(notificationId: string, state: string) {
    const serviceURL = `${this.baseUrl}/state-push/${notificationId}/${state}`;
    const response = await axios.put(serviceURL);
    return response.data;
  }
  async getPhoneStatus(phone: string) {
    const serviceURL = `${this.baseUrl}/phone-state/${phone}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
